import { Methods } from "@newview/infrastructure";
import { NewviewOaBaseApi } from "./NewviewOaBaseApi";


export class RewardInfoApi extends NewviewOaBaseApi {

    public get ControllerName(): any {
        return 'reward-info'
    }


 

}